import Axios from 'axios';
import {getCharityId} from './charity';


window.onclick = function (event) {
  if (event.target.classList.contains('dropbtn') ||
    (event.target.closest('.input-select-wrap') && event.target.querySelector('.dropbtn'))) {
    event.stopPropagation();
    event.preventDefault();

    let tElement = event.target.classList.contains('dropbtn') ? event.target : event.target.querySelector('.dropbtn');

    if (event.target.classList.contains('dropbtn-only-one') && !tElement.classList.contains('is-shown')) {
      closeAllDropdowns();
    }

    document.querySelector(tElement.getAttribute('data-dropdown')).classList.toggle('show');
    tElement.classList.toggle('is-shown');

    return false;
  } else {
    if (event.target.closest('.dropdown-content')) {
      if (event.target.closest('.dropdown-content').classList.contains('dropdown-no-close')) {
        return true;
      }
    }
    //
    if (event.target.closest('.dropdown-attach-to-msg')) {
      if (event.target.closest('.item')) {
        if (event.target.closest('.item').tagName !== 'A' && !event.target.closest('.item-picture')) {
          return false;
        }
      } else {
        if (event.target.tagName === 'INPUT') {
          return true;
        }
        return false;
      }
    }
    closeAllDropdowns();
  }
};

function closeAllDropdowns() {
  const dropdowns = document.querySelectorAll('.dropdown-content');
  for (let i = 0; i < dropdowns.length; i++) {
    if (dropdowns[i].classList.contains('show')) {
      dropdowns[i].classList.remove('show');
    }
  }

  const dShown = document.querySelectorAll('.dropbtn.is-shown');
  for (let i = 0; i < dShown.length; i++) {
    dShown[i].classList.remove('is-shown');
  }
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    let el = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

function formatMoney(val, n, x) {
  if (val % 1 !== 0 && n < 2) {
    n = 2;
  }
  let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
  return val.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
}

function capitalize([first, ...rest]) {
  return first.toUpperCase() + rest.join('').toLowerCase();
}

function ucwords(str) {
  return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
    return $1.toUpperCase();
  });
}

function saveCSV(arr, opts) {
  if (!Array.isArray(arr) || !arr.length) {
    throw new Error('Expected an array of values, got ' + arr);
  }

  opts = opts || {};
  opts.filename = opts.filename || 'export.csv';
  opts.sep = opts.sep || 'auto';
  opts.eol = opts.eol || '\r\n';
  opts.bom = typeof opts.bom === 'boolean' ? opts.bom : true;
  opts.quote = opts.quote || '"';
  opts.mime = opts.mime || 'text/csv;charset=utf-8';
  opts.addHeader = typeof opts.addHeader === 'boolean' ? opts.addHeader : true;

  // This is not ideal, but given that Array.prototype.toLocaleString is
  // rather unreliable, it's a good compromise.
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1388777
  // https://bugs.chromium.org/p/chromium/issues/detail?id=753841
  if (opts.sep === 'auto') {
    if ('toLocaleString' in Number.prototype) {
      opts.sep = (1.2).toLocaleString().substring(1, 2) === ',' ? ';' : ',';
    } else {
      opts.sep = ',';
    }
  }

  const quoteRe = new RegExp(opts.quote, 'g');
  const sepRe = new RegExp(opts.sep, 'g');
  const eolRe = new RegExp(/\r?\n/g, 'g');

  opts.formatter = opts.formatter || function (value) {
    let quoted = false;
    quoteRe.lastIndex = 0;
    sepRe.lastIndex = 0;
    eolRe.lastIndex = 0;

    if (typeof value !== 'string') {
      value = JSON.stringify(value) || '';
    }

    // escape quotes by doubling the quotes and wrapping in quotes
    if (quoteRe.test(value)) {
      value = opts.quote + value.replace(quoteRe, opts.quote + opts.quote) + opts.quote;
      quoted = true;
    }

    // escape eol by wrapping in quotes
    if (eolRe.test(value)) {
      value = opts.quote + value + opts.quote;
      quoted = true;
    }

    // escape separator by wrapping in quotes
    if (sepRe.test(value) && !quoted) {
      value = opts.quote + value + opts.quote;
    }

    return value;
  };

  // build headers from first element in array
  let header = '';
  if (opts.addHeader) {
    const paths = [];
    (function scan(prefix, obj, keys) {
      keys.forEach(function (key) {
        const path = prefix ? prefix + '.' + key : key;
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          scan(path, obj[key], Object.keys(obj[key]));
        } else {
          paths.push(opts.formatter(path));
        }
      });
    })(null, arr[0], Object.keys(arr[0]));
    header = paths.join(opts.sep) + opts.eol;
  }

  // build body
  const body = arr.map(function (obj) {
    const row = [];
    (function scan(obj, keys) {
      keys.forEach(function (key) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          scan(obj[key], Object.keys(obj[key]));
        } else {
          row.push(opts.formatter(obj[key]));
        }
      });
    })(obj, Object.keys(obj));
    return row.join(opts.sep);
  }).join(opts.eol);

  // build a link and trigger a download
  const text = header + body;
  const blob = new Blob([opts.bom ? '\ufeff' + text : text]);

  if (window.navigator.msSaveBlob) { // compat: ie10
    window.navigator.msSaveBlob(blob, opts.filename);
  } else {
    const a = document.createElement('a');
    a.setAttribute('href', URL.createObjectURL(blob, {type: opts.mime}));
    a.setAttribute('download', opts.filename);
    a.setAttribute('target', '_blank');
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
    }, 0);
  }
}

/**
 * get Scrollbar Width
 * @returns {number}
 */
function getScrollbarWidth() {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

  document.body.appendChild(outer);

  const widthNoScroll = outer.offsetWidth;
  // force scrollbars
  outer.style.overflow = 'scroll';

  // add innerdiv
  const inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  const widthWithScroll = inner.offsetWidth;

  // remove divs
  outer.parentNode.removeChild(outer);

  return widthNoScroll - widthWithScroll;
}

function arrayMove(arr, fromIndex, toIndex) {
  const element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
}

// HTML Entity map for `escapeHtml`.
var entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '\'': '&#39;',
  '/': '&#x2F;',
  '`': '&#x60;',
  '=': '&#x3D;',
};

/**
 * Escape a string using HTML Entities.
 *
 * This is taken from Mustache.js:
 * https://github.com/janl/mustache.js/blob/master/mustache.js#L84
 *
 * @param {string} string
 */
function escapeHtml(string) {
  return String(string).replace(/[&<>"'`=/]/g, function fromEntityMap(s) {
    return entityMap[s];
  });
}

const projectSettings = {
  features: {
    custom_donate_button: false,
    download_report: true,
    messages_attachments: false,
    messages_keywords: false,
    auto_messages: false,
  },

  isAllowed(feature) {
    if (getCharityId() !== '5eafa414209b233147eb') {
      return true;
    }
    return this.features.hasOwnProperty(feature) && this.features[feature];
  },
  canAddCampaign() {
    if (getCharityId() !== '5eafa414209b233147eb') {
      return true;
    }
    return false;
  },
};

function isString(t) {
  return (typeof t === 'string' || t instanceof String)
}

function prepareDonationParams(params) {
  if (params.hasOwnProperty('campaignId') && !params.hasOwnProperty('campaign_id')) {
    params['campaign_id'] = Number(params['campaignId'])
  }
  if (params.hasOwnProperty('designationId') && !params.hasOwnProperty('designation_id')) {
    params['designation_id'] = Number(params['designationId'])
  }

  if (params.hasOwnProperty('campaign_id') && isString(params['campaign_id'])) {
    params['campaign_id'] = Number(params['campaign_id'])
  }
  if (params.hasOwnProperty('designation_id') && isString(params['designation_id'])) {
    params['designation_id'] = Number(params['designation_id'])
  }
  return params;
}

function randomString(length) {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function getImageFromURL(url) {
  return new Promise((resolve, reject) => {
    Axios({
      url: url,
      method: 'GET',
      responseType: 'blob',
    }).then((blob) => {
      let file = new File([blob.data], randomString(8), {
        type: blob.data.type
      });
      resolve(file)
    }).catch((error) => {
      reject(error)
    })
  })
}

export {
  projectSettings,
  formatMoney,
  capitalize,
  closeAllDropdowns,
  ucwords,
  saveCSV,
  getScrollbarWidth,
  arrayMove,
  escapeHtml,
  isString,
  getImageFromURL,
  prepareDonationParams,
};
